import { useEffect } from 'react'

const APP_NAME = 'Callizy'

/**
 * Met à jour le `<title>` du document au format "Page | Callizy".
 * - Si `pageTitle` est vide/null → affiche juste "Callizy".
 * - Restaure le titre précédent au démontage pour rester propre lors des transitions.
 */
export function useDocumentTitle(pageTitle?: string | null): void {
  useEffect(() => {
    const previous = document.title
    document.title = pageTitle ? `${pageTitle} | ${APP_NAME}` : APP_NAME
    return () => {
      document.title = previous
    }
  }, [pageTitle])
}
